// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"472":"settings","594":"about"}[chunkId] + "-legacy." + {"472":"c6b27475","594":"f3bdfed9"}[chunkId] + ".js";
};